exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".small[data-v-67e46732]{font-size:0}", ""]);

